export default __webpack_public_path__ + "5e34a2b8ae5051a77b3118e040c065ac.svg";